<template>
  <Form ref="submitData" :model="submitData" :rules="ruleValidate" :label-width="100" class="edit-win">
    <div>客户信息</div>
    <FormItem label="设备号" prop="deviceNum">
      <span class="mandatory">*</span><Input v-model="submitData.devicenum" placeholder="请输入" @blur="testDevice()" style="width: 300px"/>
    </FormItem>
    <FormItem label="设备号2" prop="deviceNum">
      <Input v-model="submitData.devicenum2" placeholder="请输入" style="width: 300px"/>
    </FormItem>
    <FormItem label="客户类型" prop="customertype">
      <Select v-model="submitData.customertype" style="width:300px;">
        <Option :value="1">个人车主</Option>
        <Option :value="2">企业车主</Option>
      </Select>
    </FormItem>
    <FormItem label="保单期限" prop="policydate">
      <Select v-model="submitData.policydate" style="width:300px;">
        <Option :value="1">1年</Option>
        <Option :value="2">2年</Option>
        <Option :value="3">3年</Option>
        <Option :value="4">4年</Option>
        <Option :value="5">5年</Option>
      </Select>
    </FormItem>
     <FormItem label="打印模板" >
      <Select v-model="selecttemp" multiple style="width:150px;" placeholder="请选择打印模板">
        <Option v-for="item in showDate" :key="item.id" :value="item.id">{{item.name}}</Option>
      </Select>
    </FormItem>
    
    <FormItem label="联系电话" prop="phone">
      <Input v-model="submitData.phone" placeholder="请输入" style="width: 300px"/>
    </FormItem>
    <FormItem label="联系地址" prop="address">
      <Input v-model="submitData.address" placeholder="请输入" style="width: 300px"/>
    </FormItem>
      <FormItem label="客户名称" prop="customername">
      <Input v-model="submitData.customername" placeholder="请输入" style="width: 300px"/>
    </FormItem> 
    <FormItem label="证件类型" prop="certificatetype">
      <Select v-model="submitData.certificatetype" style="width:300px;">
        <Option :value="1">身份证</Option>
        <Option :value="2">护照</Option>
        <Option :value="3">其他</Option>
      </Select>
    </FormItem>  
    <FormItem label="证件号码" prop="certificatenum">
      <Input v-model="submitData.certificatenum" placeholder="请输入" style="width: 300px"/>
    </FormItem>
    <br>
    <div>车辆信息</div>
    <FormItem label="车架号码" prop="frame">
      <Input v-model="submitData.frame" placeholder="请输入" style="width: 300px"/>
      </FormItem>
   <FormItem label="发动机号" prop="enginenum">
      <Input v-model="submitData.enginenum" placeholder="请输入" style="width: 300px"/>
    </FormItem>
    <FormItem label="车牌号" prop="carnum">
      <Input v-model="submitData.carnum" placeholder="请输入" style="width: 300px"/>
      </FormItem>
        <FormItem label="购车时间" prop="buytime">
          <DatePicker
            v-model="submitData.buytime"
            type="date"
            placeholder="选择购车时间"
            style="width: 300px"
          ></DatePicker>
      </FormItem>
   <FormItem label="销售顾问" prop="salemanid">
      <Select v-model="submitData.salemanid" style="width:300px;">
      <Option v-for="item in selectmanList" :key="item.id" :value="item.id">{{item.name}}</Option>
      </Select>
    </FormItem>
    <FormItem label="品牌" prop="carbrandid">
      <Select v-model="submitData.carbrandid" style="width:300px;">
      <Option v-for="item in showBrandData" :key="item.id" :value="item.id">{{item.name}}</Option>
      </Select>
    </FormItem>
      <FormItem label="车系" prop="carsysid">
      <Select v-model="submitData.carsysid" style="width:300px;">
      <Option v-for="item in brandList" :key="item.id" :value="item.id">{{item.name}}</Option>
      </Select>
    </FormItem>
   <FormItem label="购车类型" prop="buycartype">  
       <Select v-model="submitData.buycartype" style="width:300px;">
        <Option :value="1">贷款车</Option>
        <Option :value="2">全款车</Option>
      </Select>
    </FormItem>
    <FormItem label="第一受益人" prop="firstbeneficiary" v-if="submitData.buycartype == 1">
      <Select v-model="submitData.firstbeneficiary" style="width:300px;" filterable>
        <Option v-for="item in firstBeneficiaryList" :key="item.id" :value="item.id">{{item.name}}</Option>
      </Select>
      </FormItem>
        <FormItem label="新车购入价格" prop="carprice">
      <Input v-model="submitData.carprice" placeholder="请输入" style="width: 300px"/>
      </FormItem>
      <FormItem label="最高赔付金额" prop="compensation">
      <Input v-model="submitData.compensation" placeholder="最高赔付金额与新车购入价一样" style="width: 300px" disabled/>
    </FormItem>
    <FormItem label="安装时间" prop="installtime">
      <DatePicker
        v-model="submitData.installtime"
        type="date"
        placeholder="选择安装时间"
        class="search-input"
          style="width: 300px"
      ></DatePicker>
    </FormItem>
    <FormItem label="安装人" prop="installman">
      <Input v-model="submitData.installman" placeholder="请输入" style="width: 300px"/>
    </FormItem>
    <FormItem label="安装地点" prop="installaddress">
      <Input v-model="submitData.installaddress" placeholder="请输入" style="width: 300px"/>
    </FormItem>
   <FormItem label="保单金额" prop="policyamount">
      <Input v-model="submitData.policyamount" placeholder="请输入" style="width: 300px"/>
    </FormItem>
    <div @click="clickword()">轮胎信息-{{word()}}</div>
    <div v-if="showAll">
    <FormItem label="左前轮轮胎品牌" prop="lfbrand">
      <Select v-model="submitData.tyreSsinfo.lfbrand" style="width:300px;">
      <Option v-for="item in luntaibrandList" :key="item.id" :value="item.id">{{item.name}}</Option>
      </Select>
    </FormItem>
    <FormItem label="左前轮规格" prop="lfgg">
      <Input v-model="submitData.tyreSsinfo.lfgg" placeholder="请输入" style="width: 300px"/>
    </FormItem>
    <FormItem label="左前轮生产批次" prop="lfpc">
      <Input v-model="submitData.tyreSsinfo.lfpc" placeholder="请输入" style="width: 300px"/>
    </FormItem>
    <FormItem label="左前轮DOT号" prop="lfdot">
      <Input v-model="submitData.tyreSsinfo.lfdot" placeholder="请输入" style="width: 300px"/>
    </FormItem>
    <FormItem label="左前轮最高赔偿限额" prop="lfamount">
      <Input v-model="submitData.tyreSsinfo.lfamount" placeholder="请输入" style="width: 300px"/>
      </FormItem>

    <FormItem label="右前轮轮胎品牌" prop="rfbrand">
      <Select v-model="submitData.tyreSsinfo.rfbrand" style="width:300px;">
      <Option v-for="item in luntaibrandList" :key="item.id" :value="item.id">{{item.name}}</Option>
      </Select>
    </FormItem>
    <FormItem label="右前轮规格" prop="rfgg">
      <Input v-model="submitData.tyreSsinfo.rfgg" placeholder="请输入" style="width: 300px"/>
    </FormItem>
    <FormItem label="右前轮生产批次" prop="rfpc">
      <Input v-model="submitData.tyreSsinfo.rfpc" placeholder="请输入" style="width: 300px"/>
    </FormItem>
    <FormItem label="右前轮DOT号" prop="rfdot">
      <Input v-model="submitData.tyreSsinfo.rfdot" placeholder="请输入" style="width: 300px"/>
    </FormItem>
    <FormItem label="右前轮最高赔偿限额" prop="rfamount">
      <Input v-model="submitData.tyreSsinfo.rfamount" placeholder="请输入" style="width: 300px"/>
      </FormItem>

    <FormItem label="左后轮轮胎品牌" prop="lbbrand">
      <Select v-model="submitData.tyreSsinfo.lbbrand" style="width:300px;">
      <Option v-for="item in luntaibrandList" :key="item.id" :value="item.id">{{item.name}}</Option>
      </Select>
    </FormItem>
    <FormItem label="左后轮规格" prop="lbgg">
      <Input v-model="submitData.tyreSsinfo.lbgg" placeholder="请输入" style="width: 300px"/>
    </FormItem>
    <FormItem label="左后轮生产批次" prop="lbpc">
      <Input v-model="submitData.tyreSsinfo.lbpc" placeholder="请输入" style="width: 300px"/>
    </FormItem>
    <FormItem label="左后轮DOT号" prop="lbdot">
      <Input v-model="submitData.tyreSsinfo.lbdot" placeholder="请输入" style="width: 300px"/>
    </FormItem>
    <FormItem label="左后轮最高赔偿限额" prop="lbamount">
      <Input v-model="submitData.tyreSsinfo.lbamount" placeholder="请输入" style="width: 300px"/>
    </FormItem>
    <FormItem label="右后轮轮胎品牌" prop="rbbrand">
      <Select v-model="submitData.tyreSsinfo.rbbrand" style="width:300px;">
      <Option v-for="item in luntaibrandList" :key="item.id" :value="item.id">{{item.name}}</Option>
      </Select>
    </FormItem>
    <FormItem label="右后轮规格" prop="rbgg">
      <Input v-model="submitData.tyreSsinfo.rbgg" placeholder="请输入" style="width: 300px"/>
    </FormItem>
    <FormItem label="右后轮生产批次" prop="rbpc">
      <Input v-model="submitData.tyreSsinfo.rbpc" placeholder="请输入" style="width: 300px"/>
    </FormItem>
    <FormItem label="右后轮DOT号" prop="rbdot">
      <Input v-model="submitData.tyreSsinfo.rbdot" placeholder="请输入" style="width: 300px"/>
    </FormItem>
    <FormItem label="右后轮最高赔偿限额" prop="rbamount">
      <Input v-model="submitData.tyreSsinfo.rbamount" placeholder="请输入" style="width: 300px"/>
    </FormItem>

    <FormItem label="经销商名称" prop="jxsname">
      <Input v-model="submitData.jxsname" placeholder="请输入" style="width: 300px"/>
    </FormItem>
    <FormItem label="联系方式" prop="jxsphone">
      <Input v-model="submitData.jxsphone" placeholder="请输入" style="width: 300px"/>
    </FormItem>
    <FormItem label="地址" prop="jxsaddr">
      <Input v-model="submitData.jxsaddr" placeholder="请输入" style="width: 300px"/>
    </FormItem>

      <FormItem label="保障金额" prop="servicenum">
      <Input v-model="submitData.servicenum" placeholder="请输入" style="width: 300px"/>
      </FormItem>
       <FormItem label="总赔偿限额" prop="servicetotalamount">
      <Input v-model="submitData.servicetotalamount" placeholder="请输入" style="width: 300px"/>
      </FormItem>
</div>
    <FormItem>
      <Button @click="submitInfo()" type="primary">确定</Button>
      <Button @click="$router.go(-1)" style="margin-left: 8px">返回</Button>
    </FormItem>
  </Form>
</template>
<script>
import { fail } from 'assert';
export default {
  data() {
    return {
      showAll:false, 
      menudata: [],
      firstBeneficiaryList: [], //第一受益人列表
      brandList: [],   //品牌列表
      luntaibrandList: [],//轮胎品牌列表
      showBrandData:[],  //车系列表
      selectmanList: [], //销售顾问
      selecttemp:[],//选择打印模板
      show: false,
      showDate: {
        change:'',
        printlimit: '',
        model:'',
        saleslip: '',
      },
      submitData: {
      devicenum: '',
      deviceid: '',
      policydate: '',
      saleslipModels:[],
      pnum: '',
      phone: '',
      address: '',
      customertype: '',
      customername: '',
      certificatetype: '',
      certificatenum: '',
      carnum: '',
      enginenum: '',
      frame: '',
      buytime: '',
      salemanid: '',
      carbrandid: '',
      carsysid: '',
      buycartype: '',
      firstbeneficiary: '',
      carprice: '',
      compensation: '',
      installtime: '',
      installman: '',
      policyamount: '',
      jxsname: '',
      jxsphone: '',
      jxsaddr: '',
      servicenum: '',
      servicetotalamount: '',
      tyreSsinfo:{
      lfbrand: '',
      lfgg: '',
      lfpc: '',
      lfdot: '',
      lfamount: '',
      lbbrand: '',
      lbgg: '',
      lbpc: '',
      lbdot: '',
      lbamount: '',
      rfbrand: '',
      rfgg: '',
      rfpc: '',
      rfdot: '',
      rfamount: '',
      rbbrand: '',
      rbgg: '',
      rbpc: '',
      rbdot: '',
      rbamount: ''
      }
      },
      ruleValidate: {
        policydate: [
          { required: true, message: '保单期限不能为空', }
        ],
        selecttemps: [
          { required: true, message: '打印模板不能为空', }
        ],
        customertype: [
          { required: true, message: '客户类型不能为空', }
        ],
        phone: [
          { required: true, message: '电话不能为空', trigger: 'blur' }
        ],
        address: [
          { required: true, message: '联系地址不能为空', trigger: 'blur' }
        ],
        customername: [
          { required: true, message: '客户名称不能为空', trigger: 'blur' }
        ],
        certificatetype: [
          { required: true, message: '证件类型不能为空', }
        ],
        certificatenum: [
          { required: true, message: '证件号码不能为空', trigger: 'blur' }
        ],
        frame: [
          { required: true, message: '车架号不能为空', trigger: 'blur' }
        ],
        enginenum: [
          { required: true, message: '发动机号不能为空', trigger: 'blur' }
        ],
        salemanid: [
          { required: true, message: '销售顾问不能为空', }
        ],
        carbrandid: [
          { required: true, message: '品牌不能为空', }
        ],
        carsysid: [
          { required: true, message: '车系不能为空', }
        ],
        buycartype: [
          { required: true, message: '购车类型不能为空', }
        ],
        firstbeneficiary: [
          { required: true, message: '第一受益人不能为空', }
        ],
        buytime: [
          { required: true, message: '购车时间不能为空', trigger: 'blur', type: "date" }
        ],
        carprice: [
          { required: true, message: '购入价格不能为空', trigger: 'blur' }
        ],
        compensation: [
          { required: true, message: '最高赔付不能为空', trigger: 'blur' }
        ],
        installtime: [
          { required: true, message: '安装时间不能为空', trigger: 'blur', type: "date" }
        ],
      }
    }
  },
  watch: {
    'submitData.carbrandid'(newval,oldval) {
      this.getList(newval)
    },
    'submitData.carprice'(newval,oldval) {
      this.submitData.compensation =  newval
    },
  },
  mounted() {
    this.showAll=false
    if (this.$route.query.id) {
      this.getInfoById()
    }
    this.getFirstBeneficiary()
    this.getBrandList()
    this.getluntaiBrandList()
    this.getSelectMan()
    this.getModel()
  },
  methods: {
    word(){
      if(this.showAll == false){
        return '点击展开'
      }else{
        return '点击收起'
      }
    },
    clickword(){
      if(this.showAll == false){
        this.showAll = true
      }else{
        this.showAll = false;
      }
    },
    getInfoById() {
      this.$axios.get('/saleslip/info/' + this.$route.query.id)
        .then(function (response) {
          if (response.data.success) {
            response.data.data.buytime = new Date(response.data.data.buytime)
            response.data.data.installtime = new Date(response.data.data.installtime)
            this.submitData = response.data.data
          } else {
            this.$Message.error(response.data.errMsg);
          }
        }.bind(this))
    },
    submitInfo() {
      this.$axios.get('/saleslip/testDevice?devicenum='+this.submitData.devicenum)
      .then(function (response) {
        if (response.data.success) {
          this.submitData.deviceid = response.data.data
          this.submitData.saleslipModels = []
      this.selecttemp.forEach(element => {
        this.submitData.saleslipModels.push({modelid:element})
      });
          this.$refs.submitData.validate((valid) => {
            if (valid) {
              this.$axios.post('/saleslip/save',this.submitData)
                .then(function (response) {
                  if (response.data.success) {
                    this.$Message.success(response.data.errMsg)
                    this.$router.go(-1)
                  } else {
                    this.$Message.error(response.data.errMsg);
                  }
                }.bind(this))
              }
          })
        } else {
          this.$Modal.warning({
            title: response.data.errMsg
          })
        }
      }.bind(this))
    },
    getModel() {
      this.$Loading.start()
      this.$axios.get('/model/curgroupselect')
      .then(function (response) {
        if (response.data.success) {

          this.showDate = response.data.data
          console.log(this.showDate)
          this.$Loading.finish()
        } else {
          this.$Message.error(response.data.errMsg)
          this.$Loading.error()
        }
      }.bind(this))
    },
    getFirstBeneficiary() {
      this.$axios.get('/group/firstbeneficiarylist')
      .then(function (response) {
        if (response.data.success) {
          this.firstBeneficiaryList = response.data.data
        } else {
          this.$Message.error(response.data.errMsg)
        }
      }.bind(this))
    },
    getBrandList() {
      this.$axios.get('/car/listtwo/0')
      .then(function (response) {
        if (response.data.success) {
          this.showBrandData = response.data.data
        } else {
          this.$Message.error(response.data.errMsg)
          this.$Loading.error()
        }
      }.bind(this))
    },
    getluntaiBrandList() {
      this.$axios.get('/saleslip/tyre')
      .then(function (response) {
        if (response.data.success) {
          this.luntaibrandList = response.data.data
        } else {
          this.$Message.error(response.data.errMsg)
          this.$Loading.error()
        }
      }.bind(this))
    },
    getList (id) {
      this.$axios.get('/car/listtwo/'+id)
      .then(function (response) {
        if (response.data.success) {
          this.brandList = response.data.data
        } else {
          this.$Message.error(response.data.errMsg)
          this.$Loading.error()
        }
      }.bind(this))
    },
    getSelectMan() {
      this.$axios.get('/saleman/selectlist')
      .then(function (response) {
        if (response.data.success) {
          this.selectmanList = response.data.data
        } else {
          this.$Message.error(response.data.errMsg)
          this.$Loading.error()
        }
      }.bind(this))
    }
  }
}
</script>

<style>
.mandatory{
  position: absolute;
  content: '*';
  font-size: 20px;
  font-weight: 100;
  margin-top: 5px;
  margin-left: -60px;
  color: red;
  width: 10px;
  height: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/saleslip/add.vue